import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="border-b border-[#E4E7EC] bg-white"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
        <div className="max-w-3xl">
          <p className="overline mb-4">§ 08 — What partners say</p>
          <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tight text-[#101828] sm:text-5xl md:text-6xl">
            Trusted by forwarders on <span className="text-[#D92D20]">four continents.</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              className="bento-card flex h-full flex-col justify-between border-2 border-[#101828] bg-[#F9FAFB] p-6 md:p-8"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="h-8 w-8 text-[#D92D20]" strokeWidth={2} />
              <blockquote className="mt-4 font-display text-lg font-medium leading-snug tracking-tight text-[#101828] md:text-xl">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 border-t border-[#E4E7EC] pt-4">
                <div className="text-sm font-semibold text-[#101828]">{t.author}</div>
                <div className="font-mono-accent mt-1 text-[#475467]">{t.company}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
